module.exports = __webpack_public_path__ + "static/media/places.12abdfaf.jpg";